export const _sharedActionsConstantsShop = {
  FETCH_ALL_SHOP_BOOKS_SUCCESS: "FETCH_ALL_SHOP_BOOKS_SUCCESS",
  FETCH_SHOP_BOOKS_SUCCESS: "FETCH_SHOP_BOOKS_SUCCESS",
  SET_IS_PACKAGE_FETCHED: "SET_IS_PACKAGE_FETCHED",
  FETCH_SHOP_BOOKS_PENDING: "FETCH_SHOP_BOOKS_PENDING",
  FETCH_SHOP_BOOKS: "FETCH_SHOP_BOOKS",
  FETCH_PACKAGES_SUCCESS: "FETCH_PACKAGES_SUCCESS",
  FETCH_PACKAGES_PENDING: "FETCH_PACKAGES_PENDING",
  FETCH_PACKAGES: "FETCH_PACKAGES",
  RESET_SHOP: "RESET_SHOP",
  RESTORE_SHOP: "RESTORE_SHOP"
};

export const _sharedActionsShop = {
  fetchShopBooksSuccess: (books, bookIds) => ({
    type: _sharedActionsConstantsShop.FETCH_SHOP_BOOKS_SUCCESS,
    data: {books, bookIds}
  }),
  fetchAllShopBooksSuccess: (data) => ({
    type: _sharedActionsConstantsShop.FETCH_ALL_SHOP_BOOKS_SUCCESS,
    data
  }),
  fetchShopBooksPending: (data) => ({
    type: _sharedActionsConstantsShop.FETCH_SHOP_BOOKS_PENDING,
    data
  }),
  setIsPackageFetched: (data) => ({
    type: _sharedActionsConstantsShop.SET_IS_PACKAGE_FETCHED,
    data
  }),
  fetchShopBooks: (data) => ({
    type: _sharedActionsConstantsShop.FETCH_SHOP_BOOKS,
    data
  }),
  fetchPackagesPending: (data) => ({
    type: _sharedActionsConstantsShop.FETCH_PACKAGES_PENDING,
    data
  }),
  fetchPackagesSuccess: (data) => ({
    type: _sharedActionsConstantsShop.FETCH_PACKAGES_SUCCESS,
    data
  }),
  fetchPackages: () => ({
    type: _sharedActionsConstantsShop.FETCH_PACKAGES
  }),
  resetShop: () => ({
    type: _sharedActionsConstantsShop.RESET_SHOP
  }),
  restoreShop: (shopItems) => ({
    type: _sharedActionsConstantsShop.RESTORE_SHOP,
    data: shopItems
  })
};
